export const LOADER_PLANTILLA_COMPETENCIA            =   'LOADER_PLANTILLA_COMPETENCIA';
export const GET_PLANTILLA_COMPETENCIA               =   'GET_PLANTILLA_COMPETENCIA';
export const PLANTILLA_COMPETENCIA_FALLA             =   'PLANTILLA_COMPETENCIA_FALLA';
export const SAVE_LOADER_PLANTILLA_COMPETENCIA       =   'SAVE_LOADER_PLANTILLA_COMPETENCIA';
export const FORM_PLANTILLA_COMPETENCIA_FAIL         =   'FORM_PLANTILLA_COMPETENCIA_FAIL';
export const FORM_COPY_PLANTILLA_COMPETENCIA_FAIL    =   'FORM_COPY_PLANTILLA_COMPETENCIA_FAIL';

